// @ts-nocheck
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { inject, observer } from "../../../stores/mobx-compat";
import { withRouter } from '../../../router-compat';

import PageHeader from '../../ui/PageHeader';
import Card, { CardHead } from '../../ui/Card';
import Button from '../../ui/Button';
import IconButton from '../../ui/IconButton';
import Switch from '../../ui/Switch';
import FormGroup from '../../ui/FormGroup';
import Input from '../../ui/Input';
import Tabs from '../../ui/Tabs';
import { ChevronLeftIcon, ExternalLinkIcon } from '../../ui/icons';

/**
 * IntegrationLayout — wraps every partner page with a back button, page
 * header (logo + display name), and an optional tab nav for partner
 * sub-views (Setup, Pricing, DripCampaigns, etc.).
 */
const IntegrationLayoutInner = ({
  config, history, tabs, active, onTab, children,
}) => (
  <>
    <div className="flex items-center gap-3 mb-3">
      <IconButton icon={ChevronLeftIcon} ariaLabel="Back" onClick={() => history.push('/integrations')} />
      <span className="text-[13px] text-mov-ink-soft">All integrations</span>
    </div>
    <PageHeader
      eyebrow="Integration"
      title={config.displayName}
      sub={config.desc}
      actions={(
        <img
          src={config.logo}
          alt={config.displayName}
          style={{ width: 80, height: 60, objectFit: 'contain' }}
        />
      )}
    />
    {tabs && tabs.length > 1 && (
      <Tabs value={active} onChange={onTab} items={tabs} />
    )}
    {children}
  </>
);

export const IntegrationLayout = withRouter(IntegrationLayoutInner);

const OAuthSetupInner = ({ store, partnerKey, steps, authStepIndex = 1 }) => {
  const partner = store.integrations[partnerKey];
  const toggle = (v) => partner.setConfigField('enabled', v);

  return (
    <>
      <Card padded className="mb-5">
        <CardHead title="Setup" />
        <ol className="m-0 pl-5 flex flex-col gap-2 text-[13px] leading-relaxed">
          {steps.map((s, i) => (
            <li key={i}>
              {i === authStepIndex ? (
                <>
                  {s}{' '}
                  <button
                    type="button"
                    onClick={partner.getAuthUrl}
                    className="text-mov-accent-ink underline cursor-pointer font-medium"
                    style={{ background: 'transparent', border: 0, padding: 0 }}
                  >
                    Authorize Movology
                  </button>
                </>
              ) : s}
            </li>
          ))}
        </ol>
      </Card>

      <Card padded>
        <CardHead
          title="Manage integration"
          action={(
            <div className="flex items-center gap-2">
              <span className="text-[12.5px] text-mov-ink-soft">Enabled</span>
              <Switch checked={!!partner.configs.enabled} onChange={toggle} />
            </div>
          )}
        />
        <div className="flex justify-end">
          <Button
            variant="primary"
            loading={partner.loading}
            disabled={partner.loading}
            onClick={() => partner.updateConfigs(partnerKey)}
          >
            Update settings
          </Button>
        </div>
      </Card>
    </>
  );
};

export const OAuthSetup = inject('store')(observer(OAuthSetupInner));

const CredentialsSetupInner = ({
  store, partnerKey, steps, fields, updateKey,
}) => {
  const partner = store.integrations[partnerKey];
  const setField = (name, value) => partner.setConfigField(name, value);
  const toggle = (v) => partner.setConfigField('enabled', v);

  return (
    <>
      <Card padded className="mb-5">
        <CardHead title="Setup" />
        <ol className="m-0 pl-5 flex flex-col gap-2 text-[13px] leading-relaxed">
          {steps.map((s, i) => <li key={i}>{s}</li>)}
        </ol>
      </Card>

      <Card padded>
        <CardHead title="Credentials" />
        <div className="grid gap-4" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))' }}>
          {fields.map((f) => (
            <FormGroup key={f.name} label={f.label}>
              <Input
                value={partner.configs[f.name] || ''}
                placeholder={f.placeholder}
                disabled={partner.loading}
                onChange={(e) => setField(f.name, e.target.value)}
              />
            </FormGroup>
          ))}
        </div>
        <div className="flex items-center justify-between mt-2">
          <label className="inline-flex items-center gap-2 cursor-pointer">
            <Switch checked={!!partner.configs.enabled} onChange={toggle} />
            <span className="text-[13px]">Enabled</span>
          </label>
          <Button
            variant="primary"
            loading={partner.loading}
            disabled={partner.loading}
            onClick={() => partner.updateConfigs(updateKey || partnerKey)}
          >
            Update settings
          </Button>
        </div>
      </Card>
    </>
  );
};

export const CredentialsSetup = inject('store')(observer(CredentialsSetupInner));

export const ExternalLinkA = ({ href, children }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="inline-flex items-center gap-1 text-mov-accent-ink underline"
  >
    {children}
    <ExternalLinkIcon size={11} />
  </a>
);
